import React, { useState } from 'react'

// Эвдэрсэн эсвэл байхгүй зургийг цэвэрхэн placeholder-оор солино (гадаад файл шаардахгүй, SVG data-URI)
const PLACEHOLDER =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="240" viewBox="0 0 400 240">' +
      '<rect width="400" height="240" fill="#eef2f7"/>' +
      '<g fill="#c2ccd6"><circle cx="200" cy="96" r="30"/>' +
      '<rect x="120" y="146" width="160" height="12" rx="6"/>' +
      '<rect x="150" y="168" width="100" height="10" rx="5"/></g>' +
      '<text x="200" y="220" font-size="13" fill="#9aa7b4" text-anchor="middle" font-family="sans-serif">Зураг байхгүй</text>' +
    '</svg>'
  )

function SafeImage({ src, alt = '', ...rest }) {
  const [errored, setErrored] = useState(false)
  const isValid =
    src && !/(null|undefined)$/.test(String(src)) && String(src).trim() !== ''
  const finalSrc = !errored && isValid ? src : PLACEHOLDER
  return (
    <img
      src={finalSrc}
      alt={alt}
      onError={() => setErrored(true)}
      {...rest}
    />
  )
}

export default SafeImage
